/* eslint-disable react/prop-types */
import { Button } from '@bwoty-web/ui-kit';
import './skipLinks.scss';

const SkipLinks = ({ label }) => {
  if (!label) {
    return null;
  }

  return (
    <div className="header-skip-links">
      <Button
        className="header-skip-links__button"
        variant="secondary"
        href="#main-content"
        rel="nofollow"
      >
        {label}
      </Button>
    </div>
  );
};

export default SkipLinks;